<div class="card-content" [class.column]="column" [routerLink]="link">
    <ion-card [color]="buttonColor" class="square-card">
        <ion-icon [color]="iconColor" [icon]="icon"></ion-icon>
    </ion-card>
    <div class="card-content-inner h-100">
        <ng-content></ng-content>
    </div>
    <ion-ripple-effect *ngIf="ripple"  class="custom_color"></ion-ripple-effect>
</div>